import { render } from "./SalesReportView.vue?vue&type=template&id=2a017ad8"
import script from "./SalesReportView.vue?vue&type=script&lang=js"
export * from "./SalesReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__